<template>
    <div class="rate_mask">
        <div class="rate_dia">
            <div class="rate_dia_header">
                <h3>评价</h3>
                <img src="@/assets/images/tc_close_btn.png" alt="" @click="$emit('close')">
            </div>
            <div class="rate_dia_body">
                <div class="item">
                    <div class="label">
                        综合评分
                    </div>
                    <div class="rate">
                        <img :src="i <= rate ? require('@/assets/images/mine_pf_click.png') : require('@/assets/images/mine_pf_icon.png')"
                            alt="" v-for="i in 5" :key="i" @click="handleRate(i)">
                    </div>
                </div>
                <div class="item">
                    <div class="label">其它 <span>(选填)</span></div>
                    <div class="content">
                        <textarea v-model="other" placeholder="请输入内容"  data-mode="cn"></textarea>
                    </div>
                </div>
                <div class="btn" @click="handleSubmit">
                    提交
                </div>
            </div>
        </div>
        <vue-zzq-keyboard ref="keyboard" hand float :blurHide="true" size="mini"></vue-zzq-keyboard>
    </div>
</template>

<script>
export default {
    data() {
        return {
            rate: 0,
            other: ""
        }
    },
    methods: {
        handleRate(i) {
            this.rate = i
            console.log('评分', this.rate)
        },
        handleSubmit() {
            this.$emit('submit', { score: this.rate, notes: this.other })
        }
    }
}
</script>

<style lang="less" scoped>
.rate_mask {
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding-top: 210px;
    background: rgba(0, 0, 0, 0.5);

    .rate_dia {
        width: 858px;
        height: 640px;
        margin: 0 auto;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px 0px rgba(212, 212, 212, 0.25);
        border-radius: 16px 16px 16px 16px;

        &_header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 93px;
            padding: 8px 30px 25px;
            background-image: url(@/assets/images/Group_1321314600.png);
            background-size: 100% 100%;

            h3 {
                font-weight: 600;
                font-size: 28px;
                color: #FFFFFF;
                line-height: 33px;
                text-align: left;
            }

            img {
                width: 23px;
                height: 23px;
            }
        }

        &_body {
            width: 100%;
            height: 566px;
            margin-top: -19px;
            padding: 60px 92px 0;
            background: #FFFFFF;
            box-shadow: 0px 4px 4px 0px rgba(212, 212, 212, 0.25);
            border-radius: 16px;
            text-align: left;

            .item {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 9px;

                .label {
                    margin-bottom: 20px;
                    font-weight: 500;
                    font-size: 22px;
                    color: #111111;
                    line-height: 31px;

                    span {
                        font-weight: 500;
                        font-size: 22px;
                        color: #888888;
                        line-height: 31px;
                    }
                }

                .rate {
                    display: flex;
                    align-items: center;

                    img {
                        width: 36px;
                        height: 36px;
                        margin-right: 30px;

                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }

                .content {
                    width: 100%;

                    textarea {
                        resize: none;
                        width: 100%;
                        height: 180px;
                        padding: 14px 20px;
                        background: #FFFFFF;
                        border-radius: 10px 10px 10px 10px;
                        border: 1px solid #E2E2E2;
                        font-family: PingFangSC;
                        font-weight: 400;
                        font-size: 20px;
                        line-height: 28px;

                        &::placeholder {
                            color: #C6C6C6;
                        }
                    }
                }
            }
        }

        .btn {
            width: 300px;
            height: 66px;
            margin: 0 auto;
            margin-top: 73px;
            background: #3F87FF;
            box-shadow: 0px 6px 0px 0px #1964E0;
            border-radius: 16px 16px 16px 16px;
            font-weight: 600;
            font-size: 26px;
            color: #FFFFFF;
            line-height: 66px;
            text-align: center;
        }
    }
}
</style>